























import { defineComponent, PropType, ref } from "@vue/composition-api";
import { InputGroupMembersUpdate } from "@scrile/api-provider/dist/api/GroupsProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIconButton from "@/components/BaseIconButton";
import ListItem from "@/components/ListItem";
import { UserWithExistInGroup } from "@/views/PageGroupUsers/types";

export default defineComponent({
  name: "GroupUserItem",
  components: { BaseIconButton, BaseAvatar, BaseIcon, ListItem },
  props: {
    member: { type: Object as PropType<UserWithExistInGroup>, required: true },
    groupId: { type: String, required: true },
    isUserSubscribed: { type: Boolean, required: true },
    isSystemGroup: { type: Boolean, required: true },
  },
  setup(props, { root, emit }) {
    const loading = ref(false);
    const onItemClick = () => {
      root.$router.push(getProfileUrl(props.member));
    };

    const onIconClick = () => {
      loading.value = true;
      const data: InputGroupMembersUpdate = {
        id: props.groupId,
        memberId: props.member.id,
        status: !props.member.existInGroup,
      };
      emit("changeUser", data, () => {
        loading.value = false;
      });
    };

    return { loading, onItemClick, onIconClick };
  },
});
